module.exports = __webpack_public_path__ + "media/images/dashboard/banner_bg-10af87b0b2f33caeb94300774871be71.jpg";